import http from "../../shared/transactionApi"

const subscription = {
    state: {
        subscriptions: null, 
        paymentInfo: null,
        trials: null
    },
    actions: {
        fetchSubscriptions({commit, state}, force) {
            return new Promise((resolve, reject) => {
                if (!force) {
                    if (state.subscriptions) {
                        resolve(state.subscriptions)
                        return
                    }
                }

                http.get("/billing/subscription")
                .then((resp) => {
                    commit('SET_SUBSCRIPTIONS', resp.data)
                    resolve(resp.data)
                }).catch((err) => {
                    reject(err)
                })
            })
        },

        fetchTrials({commit, state}, force) {
            return new Promise((resolve, reject) => {
                if (!force) {
                    if (state.trials) {
                        resolve(state.trials)
                        return
                    }
                }

                http.get("/trial")
                .then((resp) => {
                    commit('SET_TRIALS', resp.data)
                    resolve(resp.data)
                }).catch((err) => {
                    reject(err)
                })
            })
        },

        fetchSubscriptionPaymentInfo({commit}) {
            return new Promise((resolve, reject) => {
                http.get("/billing/subscription/payment_info")
                .then((resp) => {
                    commit('SET_PAYMENT_INFO', resp.data)
                    resolve(resp.data)
                }).catch((err) => {
                    reject(err)
                })
            })
        },
        
        
    },
    mutations: {
        SET_SUBSCRIPTIONS (state, sub) {   
            state.subscriptions = sub
        },

        SET_PAYMENT_INFO (state, info) {   
            state.paymentInfo = info
        },

        SET_TRIALS (state, trials) {
            state.trials = trials
        },

        ADD_TRIAL (state, trial) {
            state.trials.push(trial)
        }
    },
    getters: {
        getSubscriptions(state) {
            return state.subscriptions
        },

        getSubscriptionPaymentInfo(state) {
            return state.subscription
        },

        getTrials(state) {
            return state.subscriptions.filter(s => {
                return s.is_trial
            })
        },

        isTrialUsed(state) {
            return (productid) => {
                let trials = state.trials || []

                return trials.find(t => {
                    return t.product_id == productid
                })
            }
        }
    }
  }

export default subscription